<template>
  <div class="flex flex-col gap-2 text-left">
    <div class="w-full inline-flex font-semibold text-md text-gray-900 justify-between pb-3">
      <span>Mandatory platform requirements include:</span>
    </div>
    <div class="rounded-xl relative w-full h-0" style="padding-top: 75%">
      <div
        class="
          rounded-xl
          absolute
          bg-gray-700
          text-center
          top-0
          left-0
          w-full
          h-full
          flex
          gap-6
          flex-col
          items-center
          text-sm
          justify-center
          z-10
        "
        v-if="permissionsStatus.camera !== null"
      >
        <div class="flex text-center w-full justify-center">
          <CameraPermissionBlockedIcon class="h-24 w-24" />
        </div>
        <div class="flex text-center w-full justify-center">
          <span class="text-white text-center">
            Your browser is blocking the
            <span v-if="!permissionsStatus.camera" class="font-bold">Camera&nbsp;</span>
            <span v-if="!permissionsStatus.camera && !permissionsStatus.microphone">and&nbsp;</span>
            <span v-if="!permissionsStatus.microphone" class="font-bold">Microphone</span>
            <br />
            Please grant permission to proceed.
          </span>
        </div>
      </div>
      <div
        v-else
        class="
          rounded-xl
          absolute
          bg-gray-700
          text-center
          top-0
          left-0
          w-full
          h-full
          flex
          gap-6
          flex-col
          items-center
          text-sm
          justify-center
          z-10
        "
      >
        <span class="flex items-center">
          <svg
            class="animate-spin -ml-1 h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="#14B8A6"
              stroke-width="4"
            ></circle>
            <path
              class=""
              fill="#14B8A6"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CameraPermissionBlockedIcon from '@/Components/Icons/CameraPermissionBlockedIcon.vue';

export default {
  name: 'PermissionsOverlay',
  props: {
    permissionsStatus: {
      type: Object,
      required: true,
    },
  },
  components: {
    CameraPermissionBlockedIcon,
  },
  async data() {
    if (!this.permissionsStatus.camera || !this.permissionsStatus.microphone) {
      await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
    }
  },
};
</script>

<style scoped></style>
